<template>
  <div>
    <div>
      <b>Subject</b><br>{{ processTemplate(notification.subject, notification.day) }}
    </div>
    <div class="pt-3">
      <div class="">
        <b>Message</b>
        <!-- prettier-ignore-->
        <div class="" style="white-space:pre-wrap">{{ processTemplate(notification.message,notification.day).replace(/\\n/g, "\n") }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    notification: null,
    keyItems: null,
  },
  methods: {
    processTemplate(m, days) {
      //loop through the key items and replace the keys with the values dont use regex

      if (this.keyItems) {
        this.keyItems.forEach((element) => {
          // add some context

          if (element.key == "daysPastDue") {
            m = m.replace("{{" + element.key + "}}", days);
          } else {
            m = m.replace("{{" + element.key + "}}", element.value);
          }
        });
      }

      return m;
    },
  },
};
</script>

<style></style>
